<form [formGroup]="form" [formEditablePermission]="form">
  <div class="row">
    <div class="col-md-12 d-flex align-items-center justify-content-between mb-3">
      <div class="d-flex align-items-center">
        <ng-container *ngIf="isEdit">
          <div
            class="discount-code-copy-btn"
            matTooltip="Click to copy it."
            i18n-matTooltip
            ngxClipboard
            [cbContent]="item.code"
            (cbOnSuccess)="onCopied($event)"
          >
            <ng-container i18n>Code: {{ item.code }}</ng-container>
            <i class="fal fa-copy clickable"></i>
          </div>

          <div class="ml-3 discount-code-used-info">
            <ng-container i18n>Used:</ng-container> <span>{{ item.bookings?.length || 0 }}</span>
            <ng-container i18n>Left:</ng-container>
            <span>{{ item.max_uses - (item.bookings?.length || 0) }}</span>
          </div>
        </ng-container>
      </div>
      <div>
        <div class="btn-holder text-right control-box">
          <mat-slide-toggle
            #statusToggle
            *ngIf="isEdit"
            [disabled]="1 | isReadonlyRole"
            [formControl]="statusCtrl"
            [matTooltip]="(statusCtrl.value ? 'Disable' : 'Enable') + ' this discount'"
            matTooltipPosition="below"
            class="align-middle"
            (change)="onStatusChange($event, statusToggle)"
          >
            <span *ngIf="statusCtrl.value" i18n>Enabled</span>
            <span *ngIf="!statusCtrl.value" i18n>Disabled</span>
          </mat-slide-toggle>

          <button
            type="button"
            class="btn ml-3"
            [disabled]="1 | isReadonlyRole"
            [ngClass]="primaryBtnClass"
            (click)="onSave(form)"
          >
            <span class="fas fa-save" aria-hidden="true"></span> <ng-container i18n>Save</ng-container>
          </button>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="bg-white p-3 h-100">
        <div class="row">
          <div class="col-md-12">
            <mat-form-field
              class="d-block"
              matTooltip="Select the type of discount"
              i18n-matTooltip
              matTooltipPosition="above"
            >
              <mat-select placeholder="Type" i18n-placeholder formControlName="type" required>
                <mat-option value="pct" i18n>Percent</mat-option>
                <mat-option value="flat" i18n>Flat</mat-option>
              </mat-select>
              <mat-error *ngIf="form.get('type').touched && form.get('type').hasError('required')" i18n>
                Type is required
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-12">
            <mat-form-field
              class="d-block"
              matTooltip="Enter the name for this discount"
              i18n-matTooltip
              matTooltipPosition="above"
            >
              <input matInput placeholder="Name" i18n-placeholder formControlName="name" type="text" required />
              <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('required')" i18n>
                Name is required
              </mat-error>
              <mat-error *ngIf="form.get('name').hasError('maxlength')" i18n>
                Name must be at most 50 characters
              </mat-error>
              <mat-error *ngIf="form.get('name').hasError('allWhitespace')" i18n> Name is invalid </mat-error>
              <mat-hint align="end"> {{ form.get('name').value.length || 0 }}/50</mat-hint>
            </mat-form-field>
          </div>
          <div class="col-sm-12">
            <mat-form-field
              class="d-block"
              matTooltip="Enter the description for this discount"
              i18n-matTooltip
              matTooltipPosition="above"
              style="margin-top: -5px"
            >
              <textarea
                matInput
                placeholder="Description"
                i18n-placeholder
                formControlName="description"
                type="text"
                rows="7"
                required
              ></textarea>
              <mat-error *ngIf="form.get('description').touched && form.get('description').hasError('required')" i18n>
                Description is required
              </mat-error>
              <mat-error *ngIf="form.get('description').hasError('maxlength')" i18n>
                Description must be at most 150 characters
              </mat-error>
              <mat-hint align="end"> {{ form.get('description').value.length || 0 }}/150</mat-hint>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 pl-0">
      <div class="bg-white p-3">
        <div class="row">
          <div class="col-md-6">
            <mat-form-field class="d-block">
              <input
                matInput
                matTooltip="Enter the discount amount"
                i18n-matTooltip
                matTooltipPosition="above"
                type="number"
                [placeholder]="'Amount' + (form.get('type').value === 'pct' ? '(%)' : '')"
                formControlName="amount"
                required
              />
              <mat-error *ngIf="form.get('amount').touched && form.get('amount').hasError('percent')">
                <ng-container i18n>Amount should be greater than</ng-container> <b>0</b>
                <ng-container i18n>and less than</ng-container> <b>100</b>
              </mat-error>
              <mat-error *ngIf="form.get('amount').touched && form.get('amount').hasError('positive')">
                <ng-container i18n>Amount should be greater than</ng-container> <b>0</b>
              </mat-error>
              <mat-error *ngIf="form.get('amount').touched && form.get('amount').hasError('required')" i18n>
                Amount is required
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field class="d-block">
              <input
                matInput
                matTooltip="Enter the minimum booking total required for the discount"
                i18n-matTooltip
                matTooltipPosition="above"
                type="number"
                placeholder="Booking Total"
                i18n-placeholder
                formControlName="booking_total_min"
              />
              <mat-error
                *ngIf="form.get('booking_total_min').touched && form.get('booking_total_min').hasError('positive')"
              >
                <ng-container i18n>Amount should be greater than</ng-container> <b>0</b>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field class="d-block">
              <input
                matInput
                matTooltip="Enter value for number of uses allowed for this discount"
                i18n-matTooltip
                matTooltipPosition="above"
                type="number"
                placeholder="Max Uses"
                i18n-placeholder
                formControlName="max_uses"
                required
              />
              <mat-error *ngIf="form.get('max_uses').touched && form.get('max_uses').hasError('min')" i18n>
                Max Uses should not be less than {{ item?.bookings?.length || 1 }}
              </mat-error>
              <mat-error *ngIf="form.get('max_uses').touched && form.get('max_uses').hasError('required')" i18n>
                Max Uses is required
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field class="d-block">
              <input
                matInput
                matTooltip="Enter the minimum length of stay required for the discount"
                i18n-matTooltip
                matTooltipPosition="above"
                type="number"
                placeholder="Minimum Stay (nights)"
                i18n-placeholder
                formControlName="los"
              />
              <mat-error *ngIf="form.get('los').touched && form.get('los').hasError('min')" i18n>
                Minimum Stay should not be less than 1
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-sm-6">
            <mat-form-field
              class="mat-block"
              matTooltip="Select the start date for this discount"
              i18n-matTooltip
              matTooltipPosition="above"
            >
              <input
                matInput
                [matDatepicker]="startPicker"
                [max]="maxStartDate.value"
                [min]="now"
                placeholder="Start"
                i18n-placeholder
                formControlName="start"
                (focus)="startPicker.open()"
                tabindex="4"
                readonly
              />
              <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
              <mat-datepicker #startPicker></mat-datepicker>
              <mat-error *ngIf="form.get('start').touched && form.get('start').hasError('required')" i18n>
                Value is required
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-sm-6">
            <mat-form-field
              class="mat-block"
              matTooltip="Select the end date for this discount"
              i18n-matTooltip
              matTooltipPosition="above"
            >
              <input
                matInput
                [matDatepicker]="endPicker"
                [min]="minEndDate.value"
                placeholder="Expires"
                i18n-placeholder
                formControlName="expires"
                (focus)="endPicker.open()"
                tabindex="4"
                readonly
              />
              <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
              <mat-datepicker #endPicker></mat-datepicker>
              <mat-error *ngIf="form.get('expires').touched && form.get('expires').hasError('required')" i18n>
                Value is required
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-12">
            <mat-form-field class="d-block">
              <input
                matInput
                matTooltip="Enter email address of the guest"
                i18n-matTooltip
                matTooltipPosition="above"
                type="email"
                placeholder="Email"
                i18n-placeholder
                formControlName="email"
              />
              <mat-error *ngIf="form.get('email').hasError('email')" i18n> Email is invalid</mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-12">
            <app-select-search
              [items]="rentals$ | async"
              [ctrl]="form.get('rental_id')"
              [multiple]="false"
              bindValue="id"
              bindLabel="name"
              matTooltip="Click here to select the rental for which this discount will be applied. If no Rental is selected, the discount will apply on all Rental(s)"
              i18n-matTooltip
              matTooltipPosition="above"
              placeholder="Rental"
              i18n-placeholder
            ></app-select-search>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
